/*
 * Create a global namespace for storing shared state/etc between components/scripts on the page.
 */
window.__Vend = window.__Vend || {};
export const VEND_NS = window.__Vend;
